import React from "react";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

import whats_app from "../../assets/images/whatsApp.png";
const Footer = () => {
  return (
    <div className="footer-main">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="footer-info d-flex justify-content-end">
              <div className="footer-inner">
                <p className="p-3 text-light">&copy; 2023 - Sarthi Infotech.</p>
              </div>
              <div className="media-info">
                <div className="media-info d-flex flex-row-reverse">
                  <div>
                    <a
                      href="https://wa.me/message/5GIDIAXGNMRDH1"
                      target="blank"
                    >
                      <img src={whats_app} alt="whats-app" height="53px" />
                    </a>
                  </div>
                  <div className="media-whats-app">
                    <a
                      href="https://wa.me/message/5GIDIAXGNMRDH1"
                      target="blank"
                    >
                      <WhatsAppIcon
                        style={{
                          fontSize: "50px",
                          borderRadius: "26px",
                          color: "white",
                          padding: "8px",
                        }}
                      />
                    </a>
                  </div>
                  <div className="media-instagram">
                    <a
                      href="https://instagram.com/infotechsarthi?igshid=YmMyMTA2M2Y="
                      target="blank"
                    >
                      <InstagramIcon
                        style={{
                          fontSize: "50px",
                          borderRadius: "26px",
                          color: "white",
                          padding: "8px",
                        }}
                      />
                    </a>
                  </div>
                  <div className="media-facebook">
                    <a
                      href="https://www.facebook.com/profile.php?id=100088956160233&mibextid=ZbWKwL"
                      target="blank"
                    >
                      <FacebookIcon
                        style={{
                          fontSize: "50px",
                          borderRadius: "26px",
                          color: "white",
                          padding: "8px",
                        }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
